"use strict";

var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.KameleoonEventSource = void 0;
var _ = require(".."),
  _constants = require("./constants");
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var KameleoonEventSource = /*#__PURE__*/function () {
  function KameleoonEventSource(a) {
    _classCallCheck(this, KameleoonEventSource);
    var b = a.siteCode,
      c = a.externalEventSource,
      d = a.urlProvider;
    _defineProperty(this, "eventSource", void 0), _defineProperty(this, "siteCode", void 0), _defineProperty(this, "url", void 0), _defineProperty(this, "isConnectionOpen", void 0), this.url = d.getEventSourceUrl(), this.siteCode = b, this.eventSource = c, this.isConnectionOpen = !1;
  }
  return _createClass(KameleoonEventSource, [{
    key: "isOpen",
    get: function get() {
      return this.isConnectionOpen;
    }
  }, {
    key: "open",
    value: function open(a) {
      this.eventSource.open({
        onEvent: this.handleMessage(a),
        url: this.url,
        eventType: _constants.REAL_TIME_EVENT
      }), this.isConnectionOpen = !0, _.KameleoonLogger.info(_templateObject || (_templateObject = _taggedTemplateLiteral(["Established a new SSE connection with: ", ""])), this.url);
    }
  }, {
    key: "close",
    value: function close() {
      this.eventSource.close(), this.isConnectionOpen = !1, _.KameleoonLogger.info(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["SSE connection: '", "' was successfully closed"])), this.url);
    }
  }, {
    key: "onError",
    value: function onError(a) {
      return this.eventSource.onError ? void this.eventSource.onError(a) : void _.KameleoonLogger.warning("EventSource does not have `onError` method provided. Real-time errors won't be handled.");
    }
  }, {
    key: "handleMessage",
    value: function handleMessage(a) {
      var _this = this;
      var b = function b(_b) {
        _.KameleoonLogger.debug(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["Received new message from: ", ""])), _this.url);
        var c = JSON.parse(_b.data),
          d = c.siteCode,
          e = c.ts;
        _this.siteCode === d && a(e);
      };
      return b;
    }
  }]);
}();
exports.KameleoonEventSource = KameleoonEventSource;